import { render, staticRenderFns } from "./ip_resource_list.vue?vue&type=template&id=12cb1684"
import script from "./ip_resource_list.vue?vue&type=script&lang=js"
export * from "./ip_resource_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports